import { toast } from 'react-toastify';

import Card from '../components/cards/Card';
import SInput from '../components/form/SInput';
import PDFDialog from '../components/modals/PDFDialog';
import usePdfDialogHook from '../../redux/hooks/usePdfDialogHook';
import QtyPrintComponent from '../components/form/QtyPrintComponent';
import PrintCardsContainer from '../components/cards/PrintCardsContainer';
import PageHeader from '../components/page/PageHeader';
import useUrlParams from '../hooks/useUrlParams';
import { isNullOrWhitespace } from '../helpers/string-helper';

// http://localhost:3000/production-pallets-generator?shipmentID=shipmentID&shipmentName=shipmentName&amazonReferenceID=TestAmazonID

function ProductionPalletsLabelPage() {
  const { canGenerate, isPDFDialogOpen, setIsPDFDialogOpen, pdfBase64, print } = usePdfDialogHook();

  const {
    shipmentID,
    setShipmentID,
    shipmentName,
    setShipmentName,
    amazonReferenceID,
    setAmazonReferenceID
  } = useUrlParams();

  const print4x6 = async (printQty: number, apiUrl: string) => {
    if (!isNullOrWhitespace(shipmentID) && !isNullOrWhitespace(shipmentName)) {
      await print({
        apiUrl,
        data: {
          shipmentID,
          shipmentName,
          shipmentCode: shipmentID,
          amazonRefID: amazonReferenceID
        }
      });
    } else toast.warn('Missing inputs');
  };
  const print3x2 = async (printQty: number, apiUrl: string) => {
    // The backend will generate the pallet ids
    const pallets = [];
    for (let index = 0; index < printQty; index++) {
      pallets.push({});
    }

    await print({
      apiUrl,
      data: { pallets }
    });
  };

  return (
    <div className="flex flex-col w-full">
      <PageHeader headingText="Production Pallet Label Generator" />
      <PrintCardsContainer
        leftCard={
          <Card headerText="4x6 Labels (For Ship Alone Pallets)">
            <div className="flex flex-wrap">
              <div className="flex flex-col w-full gap-4 mt-3">
                <SInput name="Shipment ID" value={shipmentID} onChange={setShipmentID} />
                <SInput name="Shipment Name" value={shipmentName} onChange={setShipmentName} />
                <SInput
                  name="Amazon Reference ID"
                  value={amazonReferenceID}
                  onChange={setAmazonReferenceID}
                />
              </div>
            </div>
          </Card>
        }
        rightCard={
          <Card headerText="Print">
            <div className="flex flex-col gap-5">
              <QtyPrintComponent
                apiUrl="production-pallet-label4x6"
                canGenerate={canGenerate}
                showQtyButtons={false}
                generateButtonText="Generate 4x6 Label"
                printFn={print4x6}
                buttonsColDir={true}
              />
            </div>
          </Card>
        }
      />
      <QtyPrintComponent
        apiUrl="production-pallet-label3x2"
        canGenerate={canGenerate}
        showQtyButtons={true}
        Qtys={[1, 5, 25]}
        generateButtonText="Generate 3x2 Label"
        printFn={print3x2}
        twoColumns={true}
        leftCardHeaderText="3x2 Labels (For All Pallets)"
      />
      <PDFDialog isOpen={isPDFDialogOpen} setIsOpen={setIsPDFDialogOpen} pdf={pdfBase64} />
    </div>
  );
}

export default ProductionPalletsLabelPage;
